/** Method key for the hook that hides an unnamed icon from assistive technology (see `icon.ts`). */
export const decorative = Symbol('decorative')
